<template>
  <div style="font-family:Arial,Helvetica,sans-serif;color:#0A1628;font-size:13px;line-height:1.4;max-width:500px;margin:0 auto;text-align:left;">
    <table
      cellpadding="0"
      cellspacing="0"
      border="0"
      style="font-family:Arial,Helvetica,sans-serif;color:#0A1628;font-size:13px;line-height:1.4;mso-line-height-rule:exactly;max-width:500px;width:100%;margin:0 auto;float:none;"
    >
      <tr>
        <td valign="top" width="112" style="padding-right:16px;text-align:center;width:112px;">
          <table cellpadding="0" cellspacing="0" border="0" align="center" style="margin:0 auto;">
            <tr>
              <td align="center" style="text-align:center;">
                <img
                  v-if="profileUrl"
                  :src="profileUrl"
                  alt="Profile"
                  width="96"
                  height="96"
                  style="display:block;width:96px;height:96px;border-radius:50%;border:0;outline:none;margin:0 auto;"
                />
                <div
                  v-else
                  style="width:96px;height:96px;border-radius:50%;background-color:#E2E8F0;color:#0A1628;font-weight:bold;font-size:20px;line-height:96px;text-align:center;"
                >
                  {{ initials }}
                </div>
              </td>
            </tr>
            <tr v-if="logoUrl">
              <td align="center" style="text-align:center;padding-top:8px;">
                <img
                  :src="logoUrl"
                  alt="ReadySpaces"
                  width="40"
                  height="40"
                  style="display:block;width:40px;height:40px;border:0;outline:none;margin:0 auto;"
                />
              </td>
            </tr>
          </table>
        </td>
        <td valign="top" style="font-family:Arial,Helvetica,sans-serif;text-align:left;">
          <table cellpadding="0" cellspacing="0" border="0">
            <tr>
              <td style="padding:0 0 2px 0;font-size:15px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;color:#0A1628;">
                {{ displayName }}
              </td>
            </tr>
            <tr v-if="displayTitle || displayDepartment">
              <td style="padding:0 0 0 0;font-size:12px;font-family:Arial,Helvetica,sans-serif;color:#7B7B7B;">
                <span v-if="displayTitle">{{ displayTitle }}</span>
                <span v-if="displayTitle && displayDepartment" style="margin:0 3px;">&middot;</span>
                <span v-if="displayDepartment">{{ displayDepartment }}</span>
              </td>
            </tr>
            <tr>
              <td style="padding:2px 0;color:#CDF6FF;font-size:14px;line-height:1;letter-spacing:-1px;font-family:Arial,Helvetica,sans-serif;">
                &mdash;&mdash;&mdash;
              </td>
            </tr>
            <tr v-if="displayEmail || displayPhone">
              <td style="padding:0 0 2px 0;font-family:Arial,Helvetica,sans-serif;">
                <a
                  v-if="displayEmail"
                  :href="`mailto:${displayEmail}`"
                  style="color:#009ACA;text-decoration:none;font-size:12px;font-family:Arial,Helvetica,sans-serif;"
                >
                  {{ displayEmail }}
                </a>
                <span v-if="displayEmail && displayPhone" style="color:#CBD5E1;margin:0 3px;">&middot;</span>
                <a
                  v-if="displayPhone"
                  :href="`tel:${displayPhoneLink}`"
                  style="color:#64748B;text-decoration:none;font-size:12px;font-family:Arial,Helvetica,sans-serif;"
                >
                  {{ displayPhone }}
                </a>
              </td>
            </tr>
            <tr v-if="displayAddress">
              <td style="padding:2px 0 0 0;font-size:11px;font-family:Arial,Helvetica,sans-serif;color:#94A3B8;">
                {{ displayAddress }}
              </td>
            </tr>
            <tr v-if="showSocialIcons">
              <td style="padding:6px 0 0 0;font-family:Arial,Helvetica,sans-serif;">
                <table cellpadding="0" cellspacing="0" border="0" role="presentation" style="display:inline-table;">
                  <tr>
                    <td v-for="link in socialLinks" :key="link.href" style="padding:0 3px 0 0;">
                      <a :href="link.href" style="text-decoration:none;">
                        <img
                          :src="link.icon"
                          :alt="link.alt"
                          width="28"
                          height="28"
                          style="display:block;width:28px;height:28px;border-radius:50%;border:0;outline:none;"
                        />
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding:10px 0 0 0;font-size:12px;font-family:Arial,Helvetica,sans-serif;">
                <a
                  :href="availabilityUrl"
                  style="color:#009ACA;text-decoration:none;font-size:12px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;"
                >View Availability</a>
                <span style="color:#CBD5E1;margin:0 4px;">&middot;</span>
                <a
                  :href="tourUrl"
                  style="color:#009ACA;text-decoration:none;font-size:12px;font-weight:normal;font-family:Arial,Helvetica,sans-serif;"
                >Book a Tour &rarr;</a>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
const SOCIAL_ICONS = {
  linkedin: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAFC0lEQVR4AdyYPYwbRRiG39kcRaJAAw0XdygRVYqg8/EjkaOMoDpBQQQVOh8FFSJIRkIkQoolIlFRcD7RAIIi6CpQSi5IkJwjUqRCRFQxR0MaiHJFnEzed8frXf+ed3dsr2PNeGbn5/veRzv7zewGmMTvy8bLqDc+QH3na+YrrN/CRuMuSxtmV7/l+jSGYzVnAlr8AW7uvEnBF0OQAJep9QJg3mZ+HkAJBgdZuuTqJcCwT2NwAZoTgu9chGzBzy8f4FfXF3lHzmOz8S+s+Q4wr3eBIOUvBKcN2ZLNeuM85COlmeTwbICf/3YwBLvf+pvGqrB4kqXf5GxWIR8Clc8MHtIDavkcXviTvqrM00pVyKd8p/SYDnCjsQEtHz1TKR15GF4KfUtDCmPjAW78+gwDyBU+X5UUticz1KASapGmMTzsD1hvLME8to0w4qEgP0ZfaZK2fRSNBpQBg0u0wZDO/2KlElfUJQa7pVGyhgO6JbAFF81G2Zhdn9O2Bad1oI7hgGbhW84oMRc9leC0DtQ5GDCMVFznA6cUsZFaQ8392voBtdcoUvWPLXaLNEt7j8puQJ0WrPmsZ8z8XEq7GBKKuwEPL3zMvhLzvKYSTzxi6OiPAd2hdprHr44Iz5Vq8oAeA95vvefZ0ezMJVhiQD2ks5Pk13OCxQEq+rhNc7SjeekVi5io1wFarLLuJa08/TjOPncEKr0YzGqkzdQGNK9mtZOcJ7CfX3sWn5xYhMpk39Tr1jEF0Mcek/hekkPJSd695PSZ3kUxkS1AgHJSVJ76ud/1BSO2sP3P//HFLGpk4xK1x335FpDZvIZXfvwDKn3ZzW7HHicgjmY3MHimQAf3dLdqCSt3t3q9OkpA4+1opiBj15YQ5UiqAk7UprqgVEZZfZobjfdXmlIwixdagQkyCTKRyMv9MOBrf/zFOelxQvVesKQb9Skn23LVGUmDXAYyTj53fTcMQgpEqmc0M9Y0LdG9sUZ6HHQ2sZ1s7/7n0XKPKYu9gEv0dk/zVC97I+7K4hP+/BvcDgDb9GexaJZsk4C4WTRZHvXcJKC54dFgwUyZGwEeoFEwVf7kkC3Au+VfuNlPPZL6oxhiiRFUbFyiHGDsT/zPnRTyta+1c8feZb5VRG0qOx3titqiLBvt5nxFm6kNiK181txshXztcVF2rUB0HZVRe1RG7SplI2rPVRrH5ADXlr+f9X6YC6Z3Mvc/iIntDpAVPod1FY9EtuiwxIAHFr54JOAEkWCJAd85scu+GvO8pxocS8gRA+ryTutTFvN8dGvCMRDDpW7A91/cg7Efuq45/Jd2MSSkdwOqQ9En8ZCqaS6yNEt7j9h+QA1YL6/zLeOqqvOR7VWEmvvVDgbUONt6i8U8PI9NOK2U25+GA66/9BeHrxb6AKANHViF00q5/Wk4oMZWytd4ADjFahHvJO8cTkEaKXBYGg2oWTJg760U65nkMydN0iaNI/L+gJqsJVBZfoF3s3MEUvNMsqKltEjTGALGA4wMKVIZe5qXs1iyTe7Rp4dFS2oamNIBysQa3zzutI6xOs1jXY0nlGPRGwJ9j53SA8q0TguV8kc4sHCEl7WJRFoXIWuhD/mSTzpLm7IBRl50qJXztfJT4fKB/YHP6V7UnarUYH1mkA09BrIp2/Khvow5H2DSqZZuZfkNPiOH8AAn2XWGkfcbZp2IFNJj8BAETddnOQZnwjnr5UOQDdmiAR/pIQAAAP//OeQoHgAAAAZJREFUAwBLnbfUJYaxQwAAAABJRU5ErkJggg==',
  x: 'data:image/png;base64,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',
  instagram: 'data:image/png;base64,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',
  youtube: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAFLklEQVR4AdxYPYwbRRT+ZmOKRIEGGi7uUCKqFEHn40ciRxlBdYKCCCp0PgoqRJCMhAhCiiUiUVFwPtEAgiLoKlBKLkiQnCNSpEJEVHFCQxqIuAInk++b8drrs73eP//FmueZ3ffmve/zzrx56wCT+HzRfBGN5nto7H5FuczxTWw2/2NvnfjxTa+TDW01ZwJYiiO4tfs6AV9wRAJcItbzgHmT8iyAMgwOsvfNj8uAoU42OA/NccR3L0C+UMwnH8Evry3xiZzDVvNvWPMtYF7tI4KUH0ecPuRLPhvNc1CMlG6i5tkIfvbrQUfsXvsWndVg8Tj7Ypv3WYNiiKhiZoiQnqCWz+HSH4xVo0yr1aCYip0yYjqCm81NaPloT6UMVIB52cUWhhTOkhHc/OUpJpDL3F/VFL4nY2pQdViEKUGE8QQbzWWYR3bgMh7m5MPsK0zCNgZRPEE5MLhIH0zp/J6vVuaKushktxwHazRBvwS24bNZnI/Z6Ty2bXisQ3GMJmhK33BGmTLvrQyPdSjO4QRdpuI6HzplHm8Sq8M8iG2QoM4aZapB2/m+I8zCvg9lP0FVC9Z8us9mcS6FXRwiiPsJHi59SF2ZsqitzIpHHLr4ewR9UTvN8qsLouBBLVqg9wjea79TcKDZuYtw6RHUJp0dpGIjR7h4gso+/tCMD7QoWnERJ+L1BC3WOC6krT75KKJy9pkjGCdR+0JAyEmHU4egeVn3sooA/vTK07Dry1AflY9OLGGcRO3lQ6IfJSseN896TgH0Z4+J/F/itOm+BFAk082Kt9aPksunOJFbgACV+FDx2ty/dIz71aXHYrQJVOTGJWqPJzAdaXKSe26kMqciv297nARxNCeOsdN3/vp3rM2EDI6SoMlVmiXZJ5dI0GxdxcfXbqfikcR3vENTDqb5Qnv2t1vIQjSeRIyW52HA1/7eP84xtkWqRFRPc+JLl5k0KBJ4Gl87t/9JY57ZVkt0L/PsDBO1r3RuSjTO4CL5FIu9gEv0TvIZ+Sx1Zk6FWAjT4E4A2FZ4naVPso90nqn8UnWSJkYS3/H+bIsEcSPeKL924ktxNMQbJGiuj9aP1+iMG2+VzSK/b3M9wH00s4X3syaZDXWc+CgZv8ktwNuVn3nYZ86k2ic60zJCGDpNPl/64fehusQ3mUHFjUuUU4z9kd+Zm35pVSgSAeuIK81EPk5C27APfYhkZkCa2OHUIYht3StCBCwUER8noW3YF4HB+TCekye4vvLdNM9DB2CSXzz/IE6M4QlywH3YUPdQiEWXS4/ggdLnDwU5kYhw6RF864Re1urSL7jU4bk4Gj2Curzb/oRdrtKN82fZWvAcuhj6Cb77/B6Mfb+rXbSBsItDBHc/QSmUfSKbVLcWQoRZ2PeBHSQog43KBt8yrmi4GGKvwGEeRDucoOxs+w12i7AfW/BYCXewjSa48cKfNF+b6wJABzqwBo+VcAfbaIKyrVausgA4xeE8Pkk+OZyCMBLgqBZPULPkwP6/Ol97kntOmIRNGGNkPEFN1hKorjzHp9ktgXR7JqJsKSzClABAMoKhI2UqY0/zchZLtsUz+vSobElMQ1s6gnKxzjePu+1jHE6zrKuzQjkWviEwduKWnqBcq1qoVj7AgdIRXtYnkml9hqy7GIqlmAyWtmUjGEZRUavg65Un3PKB/Z77dC9Up+plrL8Z5EPbQD7lWzGkyyj5CEaDaulWV17jHjmE+zhJ1Rlm3q8pqoiU0nvEHRG0vM7SBmfcnI3KIciHfNFBEe0BAAAA//9Lvq4AAAAABklEQVQDAHAo9tQoW4xcAAAAAElFTkSuQmCC',
  website: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAHIUlEQVR4AdyZW2xUVRSG1xlKIhUFBdTWwQsKGjSEi21FDZcHL4iJQPABlCfT1gejiYpJMQaIsU0kmmh8sCW+iMoDBDAR8fLAJSp0KpcQJQqKlw6tCigotiYUjuvbZ/bMaTsznZlz2s7Y7HX2Onut9e/1Z1/PNCKD8fdWbI60xJ6TltZ3VPaq3i7NsS6tXSOe3u7Z8FFfYgYhl/AIrm9dpglvMkQisltzXSfirFC5U0Si4sgorb3i6VERR234yDohxhBv3SRgSTh/wQi+faBSR6RR1sdOieu8L+Is7UVE8vwzxBUDLDBbYo1CH3nC+N0LI/jal6MMsQs9JxSsQVwZp3W4xcNsEPqAKH0W0EP+BJk+o8uOal8NKkNVGoQ+6TvPHvMj2BxrFqYPayrPjkJwj5q+ySEPsNwINn9xk24ge3V91eWBPTiujtSZXMgphx4GJtgSqxJn5C4xO54UyZ/uvuREbgNklJ0gAI7sUAzd0vVZXCWqM2qHbnZV2dLKTNCbAlvE282yYQyfzctti3i5ps0jM0Gn7F2NiKoUe4mKl2vaPNMTNDuVzvO0IcXYqLmanPvn1p8gZw07VX/f4m4hZ3Lvk2VvgtwWXOeVPj6l80rucPBl3Jvg6LIX1RZVKdUS1RsPHJL5pwh6l9qhvH4lkwhZafBf0FMEL/Q8GXJHwwfn45IiyCINOaUJl5TJU7dfLdsfmCIdj04Xt7bKCDpt2PAJuVvRC0DySukRZPfxDk3J+peH8eWqqPy+Yoa8Pvs6eXDiGKkoH5mMRqcNGz74Jo1hKHCBk2J5BF1ZonooZerYUbJ/8W2yanqFwfvg5zOy9ac/je5/NB7sFGy04UsMsbyHIglOCYLOwjBASfCzhbfIzPHl8tXJf2Tuh9/Kok+PyeIbrjDwaw90CMLLqhkVxoYPvsQQCwb2wOJ6nCLCjz2O7/eSAMgb5k+SSp2KjEzVtiOyp/NvWTPrWoMIsTX7TwiyS9tpnFdxmfHBlxhiwcAWWOCk3CISkerAYArAOmIUGA1GTZtMmaskjOJ7rFWivK5OkEcnhlgwwKItsCg3naLutKBA7ISsI3CebW2nMsIIIbwwctSIfwStnXYbCxaYtAUTd5oSlMnBQESW3ez95sQ0Y1pavHmVlxuV6WkU3yNJMuGDiVgw0C0megCZrASdwFez+6NjTA6bj/9h6lwedpr2ncIWw2LmgpXZx4lGwvignTGu3PTx+a/nTG0fNvldHX/ZpgFri2ExBwzI5qDnYURP/dQvztmcs9g4uDH/uGyauanYG4tdXzsfurVXO3baiMGHdytg0G4x0QsW3UkjBQeXSCBTtDtorp1d5w3EjRsPi7O+LSl2I5mvB76/HZ02gvDh3QoYtFtM9ILFle6ITtHTBQMkAg+e7jLaPdeMNnUuD7vD7k4c+jbGYlhM215Q7cjpiIgbLyjYF/RJ/Kx5WzrpSlPbh03ef6BbW6baYljMTH65tbtxJSjHcnPO7LXxe28SPHz9WJnju7nY3ZONpG/06pmVpsn68EIsGOgWEz2AHFOCzuEAACb05L890nio0+iv1kw0NQ/WF4LuJ2nvp9gQ7IiNBQtM2oKJczgiFyUWDMSLfqEtLgdOdckdEy6VbfelLkf2QE83Te0UBoEYYsEAi7bAotwi8kT1Hj3sA++kJLNi53Hp0B2Vada2aKqZrnaEGEFGDrHTk/sp0xJfYogFA6zAojso3HSKKpTjbtdn4HLkTLfcu/07O5KyWw94RoaPW8AhhqDzEYwNHztyxIKBPbAkOCUIypbAgAkAEpy19ZvkmmRk+LhNmJMVH8HYaGDNEUMs76GI43HyCNbWbAzjPPQnxjq6asNBeXrvL/JR+1nxH9zotGHDB19/bGBdzz+BkwJ5BFXRddhCFaawE77x9W+y8OOjUvneoeQNB502bPiE2afBciXJJUVwRNmbxvh/ePi4pAg+PrNDuTWplHppEo+L4ZEiyOu5npe0Cnx1U4zhKnHxOCT7703wmbu6xXGfT1pLTSF3OPjy7k0QA7uPb5HSVBJCzuTeJ9n+BHGor67Xr4x9qKUh7j4xOffPNj1B/Nyex7QqhfUYFy9XTbd/yUyw/u4f1H1J2BcAxQyvcKCLLBEv17S4mQniXlfdpheABaoW40jqyMkCIUdNMFPJTpAoANzz84prTeqaIydyI8csMjBBgpkCdTWzdTSTVyCah0XYLcmFnHJIIDeCFoidynGX6+twTNm4ntHLM+2WmlPakh9BIGr1y+NczxRVh/Ja16Q3lCn2C0H7zrnkTxBobgt11atkRBn//GsalJ3W2yGbTB/0RZ/0nacURtB2wqWWzmurx5vpI+5mXafd1pxXjTM/M4DBMgATbPrAVqAEI+jvlKlbV/OIrpFyuShz1bRSd94NKtyI2NJTxA0RiXs2V31kpYmpry4XMMBSgDDKfwAAAP//h3Zs/gAAAAZJREFUAwCFd7zjTCgBxAAAAABJRU5ErkJggg==',
};

const SOCIAL_LINKS = [
  { href: 'https://www.linkedin.com/company/readyspaces-warehouses', alt: 'LinkedIn', icon: SOCIAL_ICONS.linkedin },
  { href: 'https://x.com/pickreadyspaces', alt: 'X', icon: SOCIAL_ICONS.x },
  { href: 'https://www.instagram.com/pickreadyspaces/', alt: 'Instagram', icon: SOCIAL_ICONS.instagram },
  { href: 'https://www.youtube.com/channel/UChXkNbJtLi27ZaVDcHLqR6w', alt: 'YouTube', icon: SOCIAL_ICONS.youtube },
  { href: 'https://readyspaces.com', alt: 'Website', icon: SOCIAL_ICONS.website },
];

export default {
  name: 'SignaturePreview',
  props: {
    profile: {
      type: [String, Array],
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    phone: {
      type: [String, Array],
      default: '',
    },
    title: {
      type: [String, Array],
      default: '',
    },
    department: {
      type: [String, Array],
      default: '',
    },
    address: {
      type: String,
      default: '',
    },
    logoUrl: {
      type: String,
      default: '',
    },
    availabilityUrl: {
      type: String,
      default: 'https://readyspaces.com/availability/?utm_source=email&utm_medium=email&utm_campaign=email-sig',
    },
    tourUrl: {
      type: String,
      default: 'https://calendly.com/d/cn5-qwk-yk7?utm_source=email&utm_medium=email&utm_campaign=email-sig',
    },
    showSocialIcons: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    socialLinks() {
      return SOCIAL_LINKS;
    },
    profileUrl() {
      return this.normalizeValue(this.profile);
    },
    displayName() {
      if (this.name) {
        return this.name;
      }
      const fullName = [this.firstName, this.lastName].filter(Boolean).join(' ').trim();
      if (fullName) {
        return fullName;
      }
      if (this.username) {
        return this.username;
      }
      if (this.email) {
        return this.email;
      }
      return 'Signature';
    },
    initials() {
      if (this.firstName || this.lastName) {
        const initials = `${(this.firstName || '').charAt(0)}${(this.lastName || '').charAt(0)}`.toUpperCase();
        return initials || 'RS';
      }
      if (this.displayName) {
        const parts = this.displayName.trim().split(/\s+/).filter(Boolean);
        if (parts.length === 1) {
          return parts[0].slice(0, 2).toUpperCase() || 'RS';
        }
        const first = parts[0].charAt(0);
        const last = parts[parts.length - 1].charAt(0);
        return `${first}${last}`.toUpperCase() || 'RS';
      }
      return 'RS';
    },
    displayEmail() {
      return this.email || '';
    },
    displayTitle() {
      return this.normalizeValue(this.title);
    },
    displayDepartment() {
      const value = this.normalizeValue(this.department);
      return value;
    },
    displayPhone() {
      return this.normalizeValue(this.phone);
    },
    displayPhoneLink() {
      if (!this.displayPhone) {
        return '';
      }
      return String(this.displayPhone).replace(/[^\d+]/g, '');
    },
    displayAddress() {
      if (!this.displayDepartment) {
        return '';
      }
      return this.address || '';
    },
  },
  methods: {
    getRawHtml() {
      return this.buildRawHtml();
    },
    normalizeValue(value) {
      if (Array.isArray(value)) {
        return value[0] || '';
      }
      return value || '';
    },
    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    escapeAttr(value) {
      return this.escapeHtml(value);
    },
    buildRawHtml() {
      const signatureMarker = '<!-- RS_SIGNATURE -->';
      const name = this.escapeHtml(this.displayName);
      const title = this.escapeHtml(this.displayTitle);
      const department = this.escapeHtml(this.displayDepartment);
      const email = this.escapeHtml(this.displayEmail);
      const phone = this.escapeHtml(this.displayPhone);
      const phoneLink = this.escapeAttr(this.displayPhoneLink);
      const address = this.escapeHtml(this.displayAddress);
      const profileUrl = this.escapeAttr(this.profileUrl);
      const logoUrl = this.escapeAttr(this.logoUrl);
      const availabilityUrl = this.escapeAttr(this.availabilityUrl);
      const tourUrl = this.escapeAttr(this.tourUrl);
      const initials = this.escapeHtml(this.initials);

      const titleDepartmentHtml = (title || department)
        ? `<tr><td style="padding:0 0 0 0;font-size:12px;font-family:Arial,Helvetica,sans-serif;color:#7B7B7B;">${title ? `<span>${title}</span>` : ''}${title && department ? '<span style="margin:0 3px;">&middot;</span>' : ''}${department ? `<span>${department}</span>` : ''}</td></tr>`
        : '';

      const contactHtml = (email || phone)
        ? `<tr><td style="padding:0 0 2px 0;font-family:Arial,Helvetica,sans-serif;">${email ? `<a href="mailto:${this.escapeAttr(this.displayEmail)}" style="color:#009ACA;text-decoration:none;font-size:12px;font-family:Arial,Helvetica,sans-serif;">${email}</a>` : ''}${email && phone ? '<span style="color:#CBD5E1;margin:0 3px;">&middot;</span>' : ''}${phone ? `<a href="tel:${phoneLink}" style="color:#64748B;text-decoration:none;font-size:12px;font-family:Arial,Helvetica,sans-serif;">${phone}</a>` : ''}</td></tr>`
        : '';

      const addressHtml = address
        ? `<tr><td style="padding:2px 0 0 0;font-size:11px;font-family:Arial,Helvetica,sans-serif;color:#94A3B8;">${address}</td></tr>`
        : '';

      const profileHtml = profileUrl
        ? `<img src="${profileUrl}" alt="Profile" width="96" height="96" style="display:block;width:96px;height:96px;border-radius:50%;border:0;outline:none;margin:0 auto;" />`
        : `<div style="width:96px;height:96px;border-radius:50%;background-color:#E2E8F0;color:#0A1628;font-weight:bold;font-size:20px;line-height:96px;text-align:center;">${initials}</div>`;

      const logoHtml = logoUrl
        ? `<img src="${logoUrl}" alt="ReadySpaces" width="40" height="40" style="display:block;width:40px;height:40px;border:0;outline:none;margin:0 auto;" />`
        : '';

      const logoSpacerHtml = logoHtml
        ? '<!--[if mso]><tr><td><br/></td></tr><![endif]-->'
        : '';

      const logoRowHtml = logoHtml
        ? `<tr><td align="center" style="text-align:center;padding-top:8px;">${logoHtml}</td></tr>`
        : '';

      const socialHtml = this.showSocialIcons
        ? `<tr><td style="padding:6px 0 0 0;font-family:Arial,Helvetica,sans-serif;"><table cellpadding="0" cellspacing="0" border="0" role="presentation" style="display:inline-table;"><tr>${SOCIAL_LINKS.map((link) => `<td style="padding:0 3px 0 0;"><a href="${link.href}" style="text-decoration:none;"><img src="${link.icon}" alt="${link.alt}" width="28" height="28" style="display:block;width:28px;height:28px;border-radius:50%;border:0;outline:none;" /></a></td>`).join('')}</tr></table></td></tr>`
        : '';

      return `
${signatureMarker}
<p style="margin:0;font-size:14px;line-height:1.5;mso-line-height-rule:exactly;">&nbsp;</p>
<p style="margin:0;font-size:14px;line-height:1.5;mso-line-height-rule:exactly;">&nbsp;</p>
<!--[if mso]><table cellpadding="0" cellspacing="0" border="0" width="500" align="left" style="font-family:Arial,Helvetica,sans-serif;"><tr><td valign="top"><![endif]-->
<table cellpadding="0" cellspacing="0" border="0" align="left" style="font-family:Arial,Helvetica,sans-serif;color:#0A1628;font-size:13px;line-height:1.4;mso-line-height-rule:exactly;max-width:500px;">
  <tr>
    <td valign="top" width="112" style="padding-right:16px;text-align:center;width:112px;">
      <!--[if mso]><table cellpadding="0" cellspacing="0" border="0" width="96"><tr><td width="96" style="width:96px;text-align:center;"><![endif]-->
      <table cellpadding="0" cellspacing="0" border="0" align="center" style="margin:0 auto;">
        <tr><td align="center" style="text-align:center;">${profileHtml}</td></tr>
        ${logoSpacerHtml}
        ${logoRowHtml}
      </table>
      <!--[if mso]></td></tr></table><![endif]-->
    </td>
    <td valign="top" style="font-family:Arial,Helvetica,sans-serif;text-align:left;">
      <table cellpadding="0" cellspacing="0" border="0">
        <tr><td style="padding:0 0 2px 0;font-size:15px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;color:#0A1628;">${name}</td></tr>
        ${titleDepartmentHtml}
        <tr><td style="padding:2px 0;color:#CDF6FF;font-size:14px;line-height:1;letter-spacing:-1px;font-family:Arial,Helvetica,sans-serif;">&mdash;&mdash;&mdash;</td></tr>
        ${contactHtml}
        ${addressHtml}
        ${socialHtml}
        <tr><td style="padding:10px 0 0 0;font-size:12px;font-family:Arial,Helvetica,sans-serif;"><a href="${availabilityUrl}" style="color:#009ACA;text-decoration:none;font-size:12px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;">View Availability</a> <span style="color:#CBD5E1;margin:0 4px;">&middot;</span> <a href="${tourUrl}" style="color:#009ACA;text-decoration:none;font-size:12px;font-weight:normal;font-family:Arial,Helvetica,sans-serif;">Book a Tour &rarr;</a></td></tr>
      </table>
    </td>
  </tr>
</table>
<!--[if mso]></td></tr></table><![endif]-->`.trim();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SignaturePreview.vue